import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import esriConfig from '@arcgis/core/config';
import { uofuMapComponentsTheme } from '@uofu-uss-gis/ui-react';
import App from './App';
import './index.css';
import '@uofu-uss-gis/ui-react/styles.css';
import '@arcgis/core/assets/esri/themes/light/main.css';
import '@arcgis/map-components/dist/components/arcgis-directions';

const arcgisApiKey = import.meta.env.VITE_ARCGIS_API_KEY;
if (arcgisApiKey) {
  esriConfig.apiKey = arcgisApiKey;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={uofuMapComponentsTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
